function initSableVideoCarousels(root = document) {
  root.querySelectorAll('[data-sable-video-section]').forEach((section) => {
    if (section.dataset.sableVideoInitialised === 'true') return;
    section.dataset.sableVideoInitialised = 'true';

    const carousel = section.querySelector('[data-sable-video-carousel]');
    const prevBtn = section.querySelector('[data-sable-video-prev]');
    const nextBtn = section.querySelector('[data-sable-video-next]');
    const items = Array.from(section.querySelectorAll('[data-sable-video-item]'));
    const tileVideos = Array.from(section.querySelectorAll('[data-sable-video-tile]'));

    const modal = section.querySelector('[data-sable-video-modal]');
    const modalVideoWrap = section.querySelector('[data-sable-video-modal-video]');
    const modalProduct = section.querySelector('[data-sable-video-modal-product]');
    const modalLink = section.querySelector('[data-sable-video-modal-link]');
    const modalMuteButton = section.querySelector('[data-sable-video-mute]');

    let currentIndex = 0;
    let sectionInView = true;

    const isModalOpen = () => modal && !modal.hasAttribute('hidden');

    const pauseTileVideos = () => {
      tileVideos.forEach((video) => video.pause());
    };

    const playTileVideoAtIndex = (index) => {
      if (!tileVideos[index] || isModalOpen()) return;

      pauseTileVideos();
      currentIndex = index;

      const video = tileVideos[index];
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      video.play().catch(() => {});
    };

    tileVideos.forEach((video, index) => {
      video.setAttribute('playsinline', '');

      video.addEventListener('play', () => {
        currentIndex = index;

        tileVideos.forEach((other, otherIndex) => {
          if (otherIndex !== index) other.pause();
        });
      });

      video.addEventListener('ended', () => {
        if (!sectionInView || isModalOpen()) return;

        let nextIndex = index + 1;
        if (nextIndex >= tileVideos.length) nextIndex = 0;

        playTileVideoAtIndex(nextIndex);
      });
    });

    const closeModal = () => {
      const modalVideo = modalVideoWrap?.querySelector('video');
      if (modalVideo) modalVideo.pause();

      if (modal) modal.setAttribute('hidden', '');
      if (modalVideoWrap) modalVideoWrap.innerHTML = '';

      if (sectionInView && tileVideos[currentIndex]) {
        tileVideos[currentIndex].play().catch(() => {});
      }
    };

    const openModal = (item) => {
      const sourceVideo = item.querySelector('[data-sable-video-tile]');
      const productUrl = item.dataset.productUrl || '';

      pauseTileVideos();

      if (modalVideoWrap) modalVideoWrap.innerHTML = '';

      if (sourceVideo && modalVideoWrap) {
        const modalVideo = sourceVideo.cloneNode(true);
        modalVideo.className = 'sable-video-modal__video-element';
        modalVideo.controls = true;
        modalVideo.muted = false;
        modalVideo.defaultMuted = false;
        modalVideo.removeAttribute('muted');
        modalVideo.setAttribute('playsinline', '');
        modalVideo.setAttribute('controlsList', 'nodownload noplaybackrate');
        modalVideoWrap.appendChild(modalVideo);

        setTimeout(() => {
          modalVideo.play().catch(() => {});
        }, 0);
      }

      if (productUrl && modalProduct && modalLink) {
        modalProduct.hidden = false;
        modalLink.href = productUrl;
      } else if (modalProduct && modalLink) {
        modalProduct.hidden = true;
        modalLink.removeAttribute('href');
      }

      if (modal) modal.removeAttribute('hidden');
    };

    items.forEach((item) => {
      const openButton = item.querySelector('[data-sable-video-open]');
      if (openButton) {
        openButton.addEventListener('click', () => openModal(item));
      }
    });

    section.querySelectorAll('[data-sable-video-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    if (modalMuteButton) {
      modalMuteButton.addEventListener('click', () => {
        const modalVideo = modalVideoWrap?.querySelector('video');
        if (!modalVideo) return;

        modalVideo.muted = !modalVideo.muted;
        modalMuteButton.setAttribute('aria-pressed', String(!modalVideo.muted));
      });
    }

    if (carousel && prevBtn && nextBtn) {
      const getScrollAmount = () => {
        const item = carousel.querySelector('[data-sable-video-item]');
        const gap = parseFloat(getComputedStyle(carousel).gap) || 0;
        return item ? item.getBoundingClientRect().width + gap : carousel.clientWidth * 0.8;
      };

      prevBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        carousel.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      });
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target !== section) return;

        if (entry.isIntersecting) {
          sectionInView = true;

          const activeVideo = tileVideos[currentIndex];
          const isAnyPlaying = tileVideos.some((video) => !video.paused && !video.ended);

          if (!isAnyPlaying && activeVideo && !isModalOpen()) {
            activeVideo.play().catch(() => {});
          }
        } else {
          sectionInView = false;
          pauseTileVideos();
        }
      });
    }, { threshold: 0.25 });

    observer.observe(section);

    if (tileVideos.length) {
      playTileVideoAtIndex(0);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSableVideoCarousels();
});

document.addEventListener('shopify:section:load', (event) => {
  initSableVideoCarousels(event.target);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-sable-video-modal]:not([hidden])').forEach((modal) => {
    const section = modal.closest('[data-sable-video-section]');
    const closeButton = section?.querySelector('[data-sable-video-close]');
    if (closeButton) closeButton.click();
  });
});